export class SubMenuValueConverter {
    toView(routerMenuItems) {
        var menuItems = [];
        routerMenuItems.forEach(function (menuItem) {
            if (menuItem.settings.parentMenu) {
                // Submenu children
                var parent = menuItems.find(x => x.title == menuItem.settings.parentMenu);
                // If it doesn't exist, then something went wrong, so not checking
                parent.children.push(menuItem);
            } else {
                // Just insert.  It should not be there multiple times or it's a bad route
                menuItems[menuItem] = menuItems[menuItem] || [];
                // Create empty children
                menuItem.children = [];
                menuItems.push(menuItem);
            }
        });

        return menuItems;
    }
}
